import $ from 'jquery';

export function initVideoControls() {
    $('#video-start-icon').on('click', function() {
        var videoContainer = $('#video-container');
        videoContainer.toggleClass('video-open');
    });
}

